import React from 'react';
import { FlagFilled } from '@ant-design/icons';

const Icon = function (props) {
    return <FlagFilled />;
}

export default Icon;